import { useApi } from '@omnipresentgroup/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useCancelContractorPaymentMutation = ({ id }: { id?: string }) => {
  const { POST } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return POST({
        path: `${API_BASE}/${API_PATH}/${id}/cancel`,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_PATH], exact: true });
    },
  });
};
